__webpack_require__.p = "https://cert.api-gaming.paviliononline.io/sdk/";